import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba5074b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "footer",
  class: "footer",
  name: "footer"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "If you have any questions, please leave your contact", -1 /* HOISTED */))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "info below and we will get back to you as soon as possible.", -1 /* HOISTED */))
const _hoisted_6 = {
  key: 0,
  class: "line"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "box_channel" }
const _hoisted_9 = { class: "record" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_PageFooterBanner = _resolveComponent("PageFooterBanner")!
  const _component_PhoneOutlined = _resolveComponent("PhoneOutlined")!
  const _component_MailOutlined = _resolveComponent("MailOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_Footer = _resolveComponent("Footer", true)!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _hoisted_3,
          (_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD))
            ? (_openBlock(), _createElementBlock("br", _hoisted_4))
            : _createCommentVNode("v-if", true),
          _hoisted_5
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_form, {
        ref: "form",
        class: "box_form",
        layout: "vertical",
        model: $data.form.data,
        rules: $data.form.rule
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: 24,
                md: 12,
                xl: 4
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    name: "name",
                    "has-feedback": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: $data.form.data.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($data.form.data.name) = $event)),
                        class: "form_input",
                        placeholder: "Name",
                        maxlength: 100,
                        "show-count": $data.form.data.name.length>0,
                        "allow-clear": ""
                      }, null, 8 /* PROPS */, ["value", "show-count"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_a_col, {
                xs: 24,
                md: 12,
                xl: 4
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    name: "mail",
                    "has-feedback": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: $data.form.data.mail,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($data.form.data.mail) = $event)),
                        class: "form_input",
                        placeholder: "Email address",
                        maxlength: 100,
                        "show-count": $data.form.data.mail.length>0,
                        "allow-clear": ""
                      }, null, 8 /* PROPS */, ["value", "show-count"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_a_col, {
                xs: 24,
                md: 12,
                xl: 4
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    name: "concern",
                    "has-feedback": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_auto_complete, {
                        value: $data.form.data.concern,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($data.form.data.concern) = $event)),
                        options: $data.expand.concern,
                        class: "form_input"
                      }, {
                        option: _withCtx((item) => [
                          _createElementVNode("span", null, _toDisplayString(item.value), 1 /* TEXT */)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: $data.form.data.concern,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($data.form.data.concern) = $event)),
                            class: "form_input",
                            placeholder: "Concern",
                            maxlength: 200,
                            "show-count": $data.form.data.concern.length>0,
                            "allow-clear": ""
                          }, null, 8 /* PROPS */, ["value", "show-count"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value", "options"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_a_col, {
                xs: 24,
                md: 12,
                xl: 4
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    name: "industry",
                    "has-feedback": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: $data.form.data.industry,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($data.form.data.industry) = $event)),
                        class: "form_input",
                        placeholder: "Industry",
                        maxlength: 200,
                        "show-count": $data.form.data.industry.length>0,
                        "allow-clear": ""
                      }, null, 8 /* PROPS */, ["value", "show-count"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_a_col, {
                xs: 24,
                md: 12,
                xl: 4
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    name: "demands",
                    "has-feedback": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: $data.form.data.demands,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($data.form.data.demands) = $event)),
                        class: "form_input",
                        placeholder: "Demands",
                        maxlength: 140,
                        "show-count": $data.form.data.demands.length>0,
                        "allow-clear": ""
                      }, null, 8 /* PROPS */, ["value", "show-count"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_a_col, {
                xs: 24,
                md: 12,
                xl: {offset:1,span:3}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        class: "button_n_1",
                        onClick: $options.submit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Confirm ")
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onClick"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model", "rules"]),
      _createVNode(_component_PageFooterBanner, { type: "overseas" }),
      _createVNode(_component_a_row, { class: "box_info" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            md: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PhoneOutlined, { rotate: 90 }),
              _createTextVNode(" Tel:  010-53655900 "),
              (_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD))
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "|"))
                : (_openBlock(), _createElementBlock("br", _hoisted_7)),
              _createVNode(_component_MailOutlined),
              _createTextVNode(" Email:  market@galaxy-future.com ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            md: 12
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.icon, (item) => {
                  return (_openBlock(), _createBlock(_component_a_popover, null, {
                    content: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        target: "_blank",
                        href: item.href
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["iconfont", `icon-${item.name}`])
                          }, null, 2 /* CLASS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Footer)
      ])
    ])
  ]))
}